/**
 * 관리자 오더 현황
 * ($j.Pages.Admin.OrderCurrent / body data-page-name="OrderCurrent")
 *
 * 진행중 오더(상태별) + 최근 N일 발주 분해(종류/장비/지역).
 */
export default class OrderCurrent {
    constructor() {
        this.palette = ['#0d6efd', '#198754', '#fd7e14', '#6610f2', '#20a8a8', '#dc3545', '#6c757d', '#e83e8c'];
    }

    initialize() {
        $('#ocRefresh').on('click', () => this._load(true));
        this._load();
    }

    async _load(nocache = false) {
        try {
            const res = await $.ajax({
                url: '/adm/ajax/stat/orders/current', type: 'get',
                data: nocache ? { nocache: 1 } : {}
            });
            if (!res.ok) return;
            $('#ocActive').text(this._c(res.active_total));
            $('#ocToday').text(this._c(res.today));
            $('#ocRecent').text(`진행중 + 최근 ${res.recent_days}일 발주`);
            this._bars('#ocByStatus', res.by_status);
            this._bars('#ocByType', res.by_type);
            this._bars('#ocByCar', res.by_car);
            this._bars('#ocBySido', res.by_sido, 10);
            if (res.cached_at) $('#ocCachedAt').text(`집계 ${res.cached_at}`);
        } catch (e) {
            console.error('오더 현황 로드 실패', e);
        }
    }

    _bars(sel, items, limit) {
        if (!items || !items.length) { $(sel).html('<span class="text-muted small">없음</span>'); return; }
        const list = limit ? items.slice(0, limit) : items;
        const total = items.reduce((a, b) => a + b.count, 0);
        const max = Math.max(...list.map(i => i.count));
        const html = list.map((i, idx) => {
            const w = max > 0 ? Math.round(i.count / max * 100) : 0;
            const pct = total > 0 ? Math.round(i.count / total * 100) : 0;
            return `<div class="row-item">
                <span class="lbl" title="${i.label}">${i.label}</span>
                <span class="bar" style="width:${Math.max(w, 3)}%;background:${this.palette[idx % this.palette.length]}"></span>
                <span class="val">${this._c(i.count)} (${pct}%)</span>
            </div>`;
        }).join('');
        $(sel).html(html);
    }

    _c(n) { return Number(n || 0).toLocaleString(); }

    destroy() {}
}
